module.exports = __webpack_public_path__ + "img/loading.ea7c35c6.svg";